module.exports = __webpack_public_path__ + "img/Facscope B.55648450.png";